import React from 'react';
import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { RiErrorWarningLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { CiMail } from 'react-icons/ci';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SuccessModal = ({ isOpen, onClose }: SuccessModalProps) => {
  const navigate = useNavigate();

  const handleClose = () => {
    onClose();
    navigate('../../login');
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent padding="xxxl">
        <ModalHeader>
          <Flex flexDirection="column" justifyContent="center" alignItems="center" marginTop="xxxl">
            <Box padding="l" width="fit-content" borderRadius="full" backgroundColor="primary.800" marginBottom="xl">
              <CiMail color="white" fontSize="2em" />
            </Box>
            <Text marginTop="xl" fontSize="2xl">Contraseña cambiada</Text>
          </Flex>
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Text align="center">Tu contraseña fue cambiada con éxito. Ahora puedes iniciar sessión.</Text>
        </ModalBody>

        <ModalFooter marginTop="xl" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
          <Button colorScheme="button-primary" onClick={handleClose}>
            Continuar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
